module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"step-valid-label":"Alle Angaben bestätigen?","title":"Prüfung"},"fr":{"step-valid-label":"Confirmer toutes les données?","title":"Contrôle"},"it":{"step-valid-label":"Confermare tutti i dati?","title":"Verifica"}}')
  delete Component.options._Ctor
}
